/**
 * @generated SignedSource<<87c9f6d0731b18564d42f1ada3bc31db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BulkUpdatePhaseDeliverablesInput = {
  projectId?: string | null;
  baselineVersionId?: string | null;
  phaseDeliverables?: ReadonlyArray<BulkUpdatePhaseDeliverableInput | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type BulkUpdatePhaseDeliverableInput = {
  id?: string | null;
  phaseId?: string | null;
  deliverableId?: string | null;
  projectId?: string | null;
};
export type bulkUpdatePhaseDeliverablesMutation$variables = {
  input: BulkUpdatePhaseDeliverablesInput;
};
export type bulkUpdatePhaseDeliverablesMutation$data = {
  readonly bulkUpdatePhaseDeliverables: {
    readonly phaseDeliverables: ReadonlyArray<{
      readonly id: string;
    } | null> | null;
  } | null;
};
export type bulkUpdatePhaseDeliverablesMutation = {
  variables: bulkUpdatePhaseDeliverablesMutation$variables;
  response: bulkUpdatePhaseDeliverablesMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BulkUpdatePhaseDeliverablesPayload",
    "kind": "LinkedField",
    "name": "bulkUpdatePhaseDeliverables",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseDeliverable",
        "kind": "LinkedField",
        "name": "phaseDeliverables",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eb88e843065fffd16f03344c5459f934",
    "id": null,
    "metadata": {},
    "name": "bulkUpdatePhaseDeliverablesMutation",
    "operationKind": "mutation",
    "text": "mutation bulkUpdatePhaseDeliverablesMutation(\n  $input: BulkUpdatePhaseDeliverablesInput!\n) {\n  bulkUpdatePhaseDeliverables(input: $input) {\n    phaseDeliverables {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c74f9205c2b34983394a046c76c33ec1";

export default node;
